import React, { useState, useEffect } from "react";
import Form from "./Form";
import Title from "../../Utils/Headers/Title";
import {
    NOTIFICATIONS_TYPE,
    ROLE_CABIN_ATTENDANT,
} from "../../../../utility/constants";
import Swal from "sweetalert2";
import LoadMask from "../../Utils/LoadMask/LoadMask";

const Container = (props) => {
    const [isUpdate, setIsUpdate] = useState(false);
    const [isView, setIsView] = useState(false);
    const [temporal_vehicle, setTemporalVehicle] = useState(null);
    const [selected_vehicles, setSelectedVehicles] = useState([]);
    const [files, setFiles] = useState([]);
    const [files_attach, setFilesAttach] = useState([]);
    const [files_update, setFilesUpdate] = useState([]);
    const [mark_lng, setMarkLng] = useState(null);
    const [mark_lat, setMarkLat] = useState(null);
    const [observations, setObservations] = useState(null);
    const { createAttachment, updateAttachment } = props;
    const [isChangeStatusEmergency, setIsChangeStatusEmergency] = useState(false);

    // Dynamic Settings
    const shouldUseSimpleForm = props.me && props.me.settings && props.me.settings.simple_form;
    const isCabinista = props.me && props.me.role === ROLE_CABIN_ATTENDANT;
    const requireVehicles = !props.me || !props.me.settings || props.me.settings.require_vehicle_assignment !== false;

    const setArrayFiles = (file) => {
        setFiles((a) => [...a, file]);
    };

    const setAttachFiles = (file) => {
        setFilesAttach((a) => [...a, file]);
    };

    const removeFiles = (index) => {
        let fd = [...files];
        let fad = [...(files_attach || [])];
        let fud = [...files_update];
        const fudi = fud[index];
        if (fudi) {
            const i = fud.indexOf(fudi);
            fud.splice(i, 1);
            setFilesUpdate(fud);
        }
        fd.splice(index, 1);
        fad.splice(index, 1);
        setFiles(fd);
        setFilesAttach(fad);
    };

    const edit = (data) => {
        let latlngValidate = false;

        // Validar lat/lng solo si NO es cabinista (Use Simple Form) y NO es Cabinista Role --> Now logic is: required if !simple && !cabinista
        // User asked to make LatLng optional for Cabinista.
        // The original code enforced validation. I need to make sure I don't trigger it.
        const shouldValidateLatLng = !shouldUseSimpleForm && !isCabinista;

        if (shouldValidateLatLng) {
            if (!data.latlng) {
                latlngValidate = true;
            }
            if (latlngValidate) {
                Swal.fire(
                    "¡Atención!",
                    "Ingrese la Latitud y longitud.",
                    "warning"
                );
                return;
            }
        }

        // Obtener tipo de emergencia seleccionado
        const selectedEmergencyType = props.emergencyTypes.filter_list.find(
            (type) => type.value === data.emergency_type
        );

        // Validar vehículos solo si NO es simple form y el tipo lo requiere Y requireVehicles es true y NO es Cabinista
        if (!shouldUseSimpleForm && !isCabinista && requireVehicles && selectedEmergencyType && selectedEmergencyType.requires_vehicle && selected_vehicles.length == 0) {
            Swal.fire(
                "¡Atención!",
                "Este tipo de emergencia requiere al menos un vehículo.",
                "warning"
            );
            return;
        }

        // Establecer modo de notificación por defecto para simple form
        if (shouldUseSimpleForm || isCabinista) {
            data.notice_form = "cabina";
        }

        if (selected_vehicles.length > 0) {
            const ids = [];
            props.item.members &&
                props.item.members.map((x) => {
                    ids.push(x.vehicle);
                });

            const vehicleExist = (vehicle) => {
                if (ids.indexOf(vehicle) > -1) {
                    return true;
                } else {
                    return false;
                }
            };
            let validate = false;
            selected_vehicles.map((x) => {
                if (vehicleExist(x.value && x.value)) {
                    validate = true;
                    return;
                }
            });

            if (validate) {
                Swal.fire(
                    "¡Atención!",
                    "No puedes agregar el mismo vehículos 2 veces, verifique los datos y vuelve a intentar.",
                    "warning"
                );
                return;
            }
        }
        // Merge selected_vehicles with data.members using data.members as source of truth for edited fields
        data.members = selected_vehicles.map((vehicle, i) => ({
            ...vehicle,
            ...(data.members && data.members[i] ? data.members[i] : {}),
        }));

        let final_files_attach = [];
        const files_to_attach = files_attach || [];
        for (let i = 0; i < files_to_attach.length; i++) {
            if (!files_to_attach[i].id) {
                final_files_attach.push({
                    file: files_to_attach[i],
                    name: "photo" + final_files_attach.length,
                });
            }
        }
        data.images_id = files_update;
        updateAttachment(
            { ...data, photo: null, photo_length: final_files_attach.length, is_change_status_emergency: isChangeStatusEmergency },
            final_files_attach
        );
    };

    const create = (data) => {
        let latlngValidate = false;
        let final_files_attach = [];

        // Validar lat/lng solo si NO es simple form
        const shouldValidateLatLng = !shouldUseSimpleForm && !isCabinista;

        if (shouldValidateLatLng) {
            if (!data.latlng) {
                latlngValidate = true;
            }
            if (latlngValidate) {
                Swal.fire(
                    "¡Atención!",
                    "Ingrese la Latitud y longitud.",
                    "warning"
                );
                return;
            }
        }

        // Obtener tipo de emergencia seleccionado
        const selectedEmergencyType = props.emergencyTypes.filter_list.find(
            (type) => type.value === data.emergency_type
        );

        // Validar vehículos
        if (!shouldUseSimpleForm && !isCabinista && requireVehicles && selectedEmergencyType && selectedEmergencyType.requires_vehicle && selectedEmergencyType.allow_vehicle !== false && selected_vehicles.length == 0) {
            Swal.fire(
                "¡Atención!",
                "Este tipo de emergencia requiere al menos un vehículo.",
                "warning"
            );
            return;
        }

        // Establecer modo de notificación por defecto
        if (shouldUseSimpleForm || isCabinista) {
            data.notice_form = "cabina";
        }

        if (data.members) {
            // Merge selected_vehicles with data.members using data.members as source of truth for edited fields
            data.members = selected_vehicles.map((vehicle, i) => ({
                ...vehicle,
                ...(data.members && data.members[i] ? data.members[i] : {}),
            }));
        }

        if (!shouldUseSimpleForm) {
            const files_to_attach = files_attach || [];
            for (let i = 0; i < files_to_attach.length; i++) {
                final_files_attach.push({
                    file: files_to_attach[i],
                    name: "photo" + i,
                });
            }
        }
        createAttachment(
            { ...data, photo: null, photo_length: (files_attach || []).length },
            final_files_attach
        );
    };

    const getSelects = (stations) => {
        // Clean current collections to avoid showing stale data in UI (especially on mobile/iPhone)
        props.cleanVehiclesList();
        props.cleanFirefightersList();
        
        // Load new data
        props.firefightersList(stations);
        props.vehiclesList(stations);
    };


    useEffect(() => {
        props.emergencyTypesFilterList();
        props.stationFilterList();
        if (
            props.match.path === "/emergency/:id/editar" &&
            props.match.params.id
        ) {
            setIsUpdate(true);
            props.leer(props.match.params.id);
        } else if (
            props.match.path === "/emergency/:id" &&
            props.match.params.id
        ) {
            setIsView(true);
            props.leer(props.match.params.id);
        } else {
            // Solo predefinir estación si NO es simple form (o role check original meant !Cabinista)
            if (props.me.station && !shouldUseSimpleForm) {
                props.estacionDefault(props.me.station.id, props.me.role);
            }
            setObservations(null);
            setSelectedVehicles([]);
            props.cleanVehiclesList();
            props.cleanFirefightersList();
        }
    }, [props.me ? props.me.id : null]);

    useEffect(() => {
        if (Object.keys(props.item).length > 0 && isUpdate) {
            let members_copy = [];
            props.item.members &&
                props.item.members.forEach((element) => {
                    let temp = { ...element };
                    // We preserve pilot and other metadata for display in the table
                    members_copy.push(temp);
                });
            setObservations(props.item.observations);
            getSelects(props.item.stations);
            setSelectedVehicles(members_copy);
            setFiles(props.item.images || []);
            setFilesAttach(props.item.images || []);
            setFilesUpdate(props.item.images_id);
            setMarkLat(parseFloat(props.item.latitude));
            setMarkLng(parseFloat(props.item.longitude));
        } else {
            if (props.me.station) {
                getSelects(props.me.station.id);
                setMarkLat(parseFloat(props.me.station.lat));
                setMarkLng(parseFloat(props.me.station.lng));
            }
        }
    }, [props.item ? props.item.id : null, isUpdate, props.me ? props.me.id : null]);
    return (
        <div className="card pb-3 mb-5">
            <div
                className={
                    isUpdate
                        ? props.item && props.item.status
                            ? `px-4 pt-4 container-title-create${props.item.status === "Activo"
                                ? "-active"
                                : props.item.status === "Critica"
                                    ? "-critical"
                                    : props.item.status === "Solicita apoyo"
                                        ? "-requesting_support"
                                        : props.item.status === "Resuelta"
                                            ? "-resolved"
                                            : ""
                            }`
                            : "px-4 pt-4 container-title-create"
                        : "px-4 pt-4 container-title-create"
                }
            >
                <Title
                    textWhite={true}
                    title={"Emergencia"}
                    subtitle={
                        isView
                            ? "Detalle"
                            : isUpdate
                                ? "Actualizar"
                                : "Crear emergencia"
                    }
                    showCreate={false}
                />
            </div>
            <div className="p-0 px-3 pt-3">
                <LoadMask loading={props.loader} blur>
                    <Form
                        mark_lat={mark_lat}
                        mark_lng={mark_lng}
                        isUpdate={isUpdate}
                        isView={isView}
                        observations_value={observations}
                        emergency_types={props.emergencyTypes.filter_list}
                        notificactions_types={NOTIFICATIONS_TYPE}
                        stations={props.stations.filter_list}
                        getSelects={getSelects}
                        firefighters={props.firefighters.firefighters}
                        pilot={props.firefighters.pilot}
                        vehicles={props.vehicles.vehicles_stations}
                        temporal_vehicle={temporal_vehicle}
                        setTemporalVehicle={setTemporalVehicle}
                        selected_vehicles={selected_vehicles}
                        setSelectedVehicles={setSelectedVehicles}
                        files={files}
                        setFiles={setAttachFiles}
                        customOnChange={setArrayFiles}
                        removeFiles={removeFiles}
                        onSubmit={isUpdate ? (data) => edit(data) : create}
                        setIsChangeStatusEmergency={setIsChangeStatusEmergency}
                        item={props.item}
                        initialValues={isUpdate || isView ? {
                            ...props.item,
                            members: Array.isArray(props.item.members) ? props.item.members : [],
                            pacients: Array.isArray(props.item.pacients) ? props.item.pacients : [],
                            contact_person: Array.isArray(props.item.contact_person) ? props.item.contact_person : [],
                            firefighters: Array.isArray(props.item.firefighters) ? props.item.firefighters : [],
                        } : {
                            members: [],
                            pacients: [],
                            contact_person: [],
                            firefighters: [],
                        }}
                        me={props.me}
                    />
                </LoadMask>
            </div>
        </div>
    );
};

export default Container;
